var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio",class:{ selected: _vm.selected, other: _vm.other, wide: _vm.wide, oval: _vm.oval },on:{"click":_vm.onClick}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }